<template>
    <div class="d-flex justify-content-center">
        <div class="main-content col-md-8 bg-white">
            <div class="heading-section mb-3 mb-md-5 col-md-8 offset-md-2">
                <h4 class="text-left font-bold text-normal mt-4">
                    THE REAL ESTATE COMPANY
                </h4>
                <span class="d-block text-left">
                    As we continue to lead the line in providing affordable housing all across the country and beyond, we are indeed honored to play a vital role in fueling your dreams of owning a house through innovation and trust worthy services, which encapsulates our real estate philosophy.
                </span>
                <div class="body-section">
                    <div class="row mx-0 justify-content-between">
                        <router-link to="/estates" class="col-md-5 px-0 mb-2">
                            <div class="overlay"></div>
                            <img class="img-fluid" src="../../assets/QXB4x57kkr.png" alt="Serviced Plots">
                            <div class="text-description">
                                <h3 class="font-bold mb-0">Serviced Plots</h3>
                                <span class="text-sm">Explore</span>
                            </div>
                        </router-link>
                        <router-link to="/our-houses" class="col-md-5 px-0 mb-2">
                            <div class="overlay"></div>
                            <img class="img-fluid" src="../../assets/AE3d2MFTIu.png" alt="Houses">
                            <div class="text-description pt-3">
                                <h3 class="font-bold mb-0">Houses</h3>
                                <span class="text-sm">Explore</span>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-12 mt-3">
                        <button class="btn-default-style download-btn bg-default-color">
                            Download Full Product Brochure
                        </button>
                        <a v-if="brochure_url"
                        :href="brochure_url"
                        target="_blank" rel="noreferrer noopener"
                        class="btn-lg btn-danger-custom download-btn">
                            DOWNLOAD FORM
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Projects',
    computed: {
        brochure_url() {
            return this.$store.state.siteData ? this.$store.state.siteData.brochure_url : ''
        }
    }
}
</script>

<style scoped>
.main-content {
    padding: 15px;
}
@media (min-width: 1200px) {
    .main-content {
        padding: 25px 60px;
    }
}
@media (min-width: 992px) {
    .main-content {
        padding: 20px 40px;
        border-radius: 20px;
        box-shadow: 10px 10px 6px #0000000D;
    }
}
.overlay {
    border-radius: 7px;
    background-color: #6E2169a2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.text-sm {
    font-size: 11px;
}
.body-section {
    margin-top: 50px;
}
@media (min-width: 992px) {
    .download-btn {
        margin-top: 30px;
    }
}
.download-btn,
.download-btn:hover {
    padding-left: 30px;
    padding-right: 30px;
    color: #fff!important;
    text-decoration: none;
    text-align: center;
    text-transform: capitalize;
}
.text-description {
    color: #fff;
    position: absolute;
    width: 100%;
    top: 30%;
    padding: 0 20%;
    text-align: center;
}
</style>